module.exports = __webpack_public_path__ + "static/media/solid-balustrade.4438a0e6.jpg";